import { render, staticRenderFns } from "./TotalAmountArea.vue?vue&type=template&id=61a913df&scoped=true&"
import script from "./TotalAmountArea.vue?vue&type=script&lang=js&"
export * from "./TotalAmountArea.vue?vue&type=script&lang=js&"
import style0 from "./TotalAmountArea.vue?vue&type=style&index=0&id=61a913df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a913df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
